import React from 'react';

const Checkbox = ({id, label, ...props}) => {
  return (
    <div className="form-check">
      <input
        id={ id }
        className="form-check-input"
        type="checkbox"
        { ...props }
      />
      <label className="form-check-label" htmlFor={ id }>
        { label }
      </label>
    </div>
  );
};

export default Checkbox;